module.exports = __webpack_public_path__ + "img/things-avatar.16849eba.png";